<template>
  <div>
    <div
      class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom"
    >
      <h1 class="h2 text-muted">MAPPING ENGINE / LOOKUP TABLES</h1>
      <button
        type="button"
        class="btn btn-primary"
        @click="$router.push('/addLookup')"
      >
        Add Lookup Table
      </button>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <input
          type="text"
          class="form-control"
          placeholder="Type to search..."
          v-model="tnameSearchQuery"
          v-on:input="debounceInput"
        />
      </div>
      <div class="col-sm-5">
        <select
          class="form-select"
          v-model="inameSearchQuery"
          v-on:input="debounceInput"
        >
          <option value="" disabled>Select Insurer</option>
          <option
            v-for="insurer in insurers"
            v-bind:value="insurer.insurer_name"
            :key="insurer.insurer_name"
          >
            {{ insurer.insurer_name }}
          </option>
        </select>
      </div>
      <div class="col-sm-1">
        <button type="button" class="btn" @click="clearSearch">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-x-circle"
            viewBox="0 0 16 16"
          >
            <path
              d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"
            />
            <path
              d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
            />
          </svg>
        </button>
      </div>
    </div>
    <table class="table mt-3">
      <colgroup>
        <col span="1" style="width: 50%;" />
        <col span="1" style="width: 50%;" />
      </colgroup>
      <thead>
        <tr>
          <th scope="col">Lookup Table</th>
          <th scope="col">Insurer</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="table in resultQuery"
          :key="table.insurer_lookup_table_id"
          @click="$router.push('/editlookup/' + table.insurer_lookup_table_id)"
          class="clickable-row"
        >
          <td
            style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
          >
            {{ table.table_name }}
          </td>
          <td
            style="max-width: 100px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; padding-right:5%"
          >
            {{ table.insurer_name }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import config from "../../config";
import _ from "lodash";
export default {
  data() {
    return {
      tables: [],
      tnameSearchQuery: "",
      inameSearchQuery: "",
      resultQuery: [],
      insurers: [],
    };
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      console.log(e.target.value);
      this.resultQuery = this.filterMap();
    }, 500),
    filterMap() {
      if (this.tnameSearchQuery || this.inameSearchQuery) {
        return this.tables.filter((table) => {
          return (
            this.tnameSearchQuery
              .toLowerCase()
              .split(" ")
              .every((v) => table.table_name.toLowerCase().includes(v)) &&
            (this.inameSearchQuery === table.insurer_name ||
              this.inameSearchQuery === "")
          );
        });
      } else {
        return this.tables;
      }
    },
    clearSearch() {
      this.tnameSearchQuery = "";
      this.inameSearchQuery = "";
      this.resultQuery = this.filterMap();
    },
    async getDeets() {
      const res = await fetch(config.baseURL + "/get_lookup_tables", {
        credentials: "include",
      });
      const data = await res.json();
      console.log(data);
      this.tables = data;
      const ires = await fetch(config.baseURL + "/get_insurers", {
        credentials: "include",
      });
      const idata = await ires.json();
      this.insurers = idata;
      this.resultQuery = this.filterMap();
    },
  },
  mounted() {
    this.getDeets();
  },
};
</script>

<style scoped>
.clickable-row {
  cursor: pointer;
}
</style>
